import Service from "./core/Service";
import { config } from "@/config";
import { $auth } from "@/services/AuthenticationService";
import { BancoClient, AxiosHttpService } from "bancojs";
/**
 * State for ApiService
 */
type ApiState = {
  client: BancoClient;
};
/**
 * Wraps bancojs library, providing an interface with Banco API.
 */
class ApiService extends Service<ApiState> {
  protected state!: ApiState;

  constructor() {
    super();
    // Create an Axios http client
    const _http = new AxiosHttpService();
    // Create a client instance and set the http client to Axios.
    const _client = new BancoClient(_http);
    // Set base URL
    _client.setBaseUrl(config.api.url);
    // Set request interceptor that injects Authorization header to all requests.
    _client.setRequestInterceptor(opts => {
      opts.headers.set("Authorization", "Bearer " + $auth.accessToken);
      return opts;
    });
    this.state = {
      client: _client
    };
  }

  get client() {
    return this.state.client;
  }
  /**
   * Returns a promise that resolves with the 'res' object provided
   * after 'timeout'.
   *
   * @param res
   * @param timeout
   */
  mockRequest<T>(res: T, timeout = 1000) {
    return new Promise<T>(resolve => {
      setTimeout(() => resolve(res), timeout);
    });
  }
}

export const $api = Service.singleton(ApiService);
